import { Map } from 'immutable';

import Actions from 'flow/actions';

const initialState = Map({
    enabled: true,
    registeredHeadsets: Map(),
});

export const headsetReducer = (state = initialState, action) => {
    switch (action && action.type) {
        case Actions.CLEAR_STATE: {
            state
                .get('registeredHeadsets')
                .forEach((headset) => headset.onDisconnect());
            return initialState;
        }
        case Actions.REGISTER_HEADSET_REF: {
            return state.setIn(
                ['registeredHeadsets', action.headsetRef.id],
                action.headsetRef,
            );
        }
        case Actions.UNREGISTER_HEADSET_REF: {
            if (state.hasIn(['registeredHeadsets', action.headsetId])) {
                state
                    .getIn(['registeredHeadsets', action.headsetId])
                    .onDisconnect();
            }
            return state.deleteIn(['registeredHeadsets', action.headsetId]);
        }
        case Actions.ENABLE_HEADSETS: {
            return state.set('enabled', true);
        }
        case Actions.DISABLE_HEADSETS: {
            return state.set('enabled', false);
        }
        case Actions.DEVICES_PREFERRED_MICROPHONE_ID: {
            return state.set('preferredMicrophoneId', action.preferredMicId);
        }
        case Actions.DEVICES_PREFERRED_AUDIO_OUTPUT_ID: {
            return state.set(
                'preferredAudioOutputId',
                action.preferredAudioOutputId,
            );
        }
        case Actions.DEVICES_PREFERRED_RINGTONE_AUDIO_OUTPUT_ID: {
            return state.set(
                'preferredRingtoneAudioOutputId',
                action.preferredRingtoneAudioOutputId,
            );
        }
        case Actions.DEVICES_PREFERRED_VIDEO_INPUT_ID: {
            return state.set(
                'preferredVideoInputId',
                action.preferredVideoInputId,
            );
        }
        case Actions.DEVICES_NOISE_SUPPRESSION_ENGINE: {
            return state.set(
                'noiseSuppressionEngine',
                action.noiseSuppressionEngine,
            );
        }
        case Actions.CONNECTED_MEDIA_DEVICES: {
            return state.set(
                'connectedMediaDevices',
                action.connectedMediaDevices,
            );
        }
        case Actions.DISABLE_HEADSETS_WHEN_MULTIPLE_CALLS: {
            return state.set('disabledExceptForCallId', action.exceptionCallId);
        }
        case Actions.ENABLE_HEADSETS_AFTER_MULTIPLE_CALLS: {
            return state.delete('disabledExceptForCallId');
        }
        default: {
            return state;
        }
    }
};

export default headsetReducer;
